// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ArrowUpSolid = function ArrowUpSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.886 1.616a1.25 1.25 0 0 0-1.77 0l-6.25 6.25a1.252 1.252 0 0 0 1.77 1.77l4.117-4.121v11.984c0 .691.559 1.25 1.25 1.25s1.25-.559 1.25-1.25V5.519l4.117 4.113a1.252 1.252 0 0 0 1.77-1.77l-6.25-6.25z"
  }));
};
